export default {
  BusinessStockEntryInform: {
    header: {
      queryCode: 'Order No.',
      queryCodeText: 'Inbound notification number / Customer Order No. / Internal Order No. / front-end Order No.',
      status: 'Inbound Status',
      receivingLogicWarehouseCode: 'Inbound Logical Warehouse',
      receivingLogicWarehouseCodeText: 'Please enter the logical warehouse code',
      beginCreationDate: 'Creation Time',
    },

    table: {
      code: 'Inbound Notification Number',
      platformOrderCode: 'Customer Order No.',
      orderCode: 'CSG Order No.',
      frontRecordCode: 'Front-end Order No.',
      inputTypeMeaning: 'Inbound Type',
      statusMeaning: 'Inbound Status',
      qty: 'Quantity To Be Received',
      receivingLogicWarehouseCode: 'Inbound Logical warehouse code',
      receivingLogicWarehouseName: 'Inbound logical warehouse name',
      storeName: 'Sales Shop',
      channelTypeCodeMeaning: 'Sales Channel',
      creationDate: 'Creation Time'
    }
  },
  BusinessStockEntryInformView: {
    title: 'Account Information',
    code: 'Inbound Notification Number',
    receivingLogicWarehouseCode: 'Inbound logical warehouse code',
    receivingLogicWarehouseName: 'Inbound logical warehouse name',
    inputTypeMeaning: 'Inbound Type',
    statusMeaning: 'Inbound Status',
    returnsName: 'Returner ',
    returnsMobile: 'Returner Phone Number',
    cptAddress: 'Returner address',
    creationDate: 'Creation time',
    logisticsInformation: 'Logistics Information',
    associated: 'Related documents',
    frontRecordCode: 'Front-end Order No.',
    orderCode: 'CSG Order No.',
    platformOrderCode: 'Third party Order No.',
    resultCode: 'Inbound result Order No.',
    productInformation: 'Product Information',
    totalQty: 'Total Incoming Quantity',
    alreadyTotalQty: 'Quantity Received',
    noDataText: 'None',

    table: {
      spuCode: 'Product Code',
      skuName: 'SKU Name',
      skuCode: 'SKU',
      plannedQty: 'Inbound Quantity',
      alreadyInputQty: 'Quantity Received',
      spuName: 'Product Name',
    }
  }
};
